import toggleLandingPageLoader from "./helpers/toggleLandingPageLoader";

const getLoaderScriptParams = (): URLSearchParams | null => {
  const loaderScript = document.getElementById("myGarageLoader");
  return loaderScript instanceof HTMLScriptElement && loaderScript.src
    ? new URL(loaderScript.src).searchParams
    : null;
};

// The page `cid` wins over the id embedded in the loader src.
const getClientId = (params: URLSearchParams | null) =>
  new URLSearchParams(window.location.search).get("cid") ||
  params?.get("id") ||
  null;

// Built with URL/searchParams so every value is encoded: a crafted `cid`
// cannot add or override params (e.g. `&cp_location_id=`) or truncate with `#`.
const buildMyGarageSrc = (clientId: string, params: URLSearchParams | null) => {
  const url = new URL(
    `${process.env.PUBLIC_URL}/MyGarageWeb.js`,
    document.baseURI,
  );
  url.searchParams.set("id", clientId);
  params?.forEach((value, key) => {
    if (key !== "id") {
      url.searchParams.append(key, value);
    }
  });
  return url.toString();
};

const injectMyGarage = () => {
  // Hosts sometimes embed the loader twice; each copy runs this file. Inject the
  // app once, since index.tsx has no guard and would mount it twice.
  if (document.querySelector("script#myGarageScript")) {
    return;
  }

  const params = getLoaderScriptParams();
  const clientId = getClientId(params);

  // No button check: the GBP landing page (mg_permanent=true) has no button and
  // relies on injection; index.tsx decides whether to render.
  if (!clientId) {
    return;
  }

  const myGarageClient = document.createElement("script");
  myGarageClient.defer = true;
  myGarageClient.id = "myGarageScript";
  myGarageClient.src = buildMyGarageSrc(clientId, params);
  document.body.appendChild(myGarageClient);
};

// Additive listener instead of `document.onreadystatechange`: that is a single
// slot, so a host assigning it after us would drop ours (and we would drop theirs).
const onReadyStateChange = () => {
  if (document.readyState !== "complete") {
    return;
  }
  document.removeEventListener("readystatechange", onReadyStateChange);
  injectMyGarage();
};

const bootstrap = () => {
  toggleLandingPageLoader(true);
  if (document.readyState === "complete") {
    injectMyGarage();
  } else {
    document.addEventListener("readystatechange", onReadyStateChange);
  }
};

bootstrap();

export {};
